import get  from "lodash/get";
import * as url from "~/routing/urls"
import store from '~/store'

export const getLocation = () => {
  if(!window) return "";
  const {pathname} = window.location;
  if(pathname.startsWith(url.SEARCHLOADS)) return "Load List";
  if(pathname.startsWith(url.LOADS)) return "Load Detail"
  return ""
} 

export const getSearchId = () => get(store.getState(), "loadsSearch.results.searchId")


// WEBPACK FOOTER //
// ./src/misc/actionLocation.js